import React, { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import ErrorMessage from 'components/common/ErrorMessage';
import { Select } from 'components/common/Select';
import { Controller } from 'react-hook-form';
import { filterUnit } from 'components/template/TemplateForm';
import { fetchLanguages } from 'slices/languageSlice';

const RateInputGroup = ({ errors, label, control, prefix, filterUnit, index, name, value, setValue }) => {

    useEffect(() => {
        setValue(name, value)
    }, [])
    return (
        <div className='Inter_rate_row'>
            <h4>{label}</h4>
            <div className='inter_wrapper'>
                {/* Rate Input */}
                <Controller
                    name={`custom_${prefix}_rate[${index}]`}
                    control={control}
                    rules={{ required: "Please enter rate" }}
                    render={({ field }) => (
                        <div className='w-100 input-dollar-group'>
                            <span className="dollar-prefix">$</span>
                            <input
                                className="input-in type_inp dollar-padding"
                                type="number"
                                placeholder={`${label} rate`}
                                {...field}
                                onChange={(e) => field.onChange(Math.max(0, parseFloat(e.target.value)))}
                            />
                            {errors?.[`custom_${prefix}_rate`] && errors[`custom_${prefix}_rate`][index] && (
                                <ErrorMessage text={errors[`custom_${prefix}_rate`][index].message} />
                            )}
                        </div>
                    )}
                />

                {/* Time Unit Select */}
                <Controller
                    name={`custom_${prefix}_rate_time_unit[${index}]`}
                    control={control}
                    rules={{ required: "Please select one" }}
                    render={({ field }) => (
                        <div className='w-100'>
                            <Select
                                name={field.name}
                                options={filterUnit || []}
                                value={
                                    filterUnit?.find(opt => opt.value === field.value) ||
                                    ""
                                }
                                isClearable={false}
                                disabledSearch
                                onChange={(selectedOption) => {
                                    field.onChange(selectedOption || "hour")
                                }}
                            />

                            {errors?.[`custom_${prefix}_rate_time_unit`] && errors[`custom_${prefix}_rate_time_unit`][index] && (
                                <ErrorMessage text={errors[`custom_${prefix}_rate_time_unit`][index].message} />
                            )}
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

const MinDurationInputGroup = ({ errors, label, control, prefix, filterUnit, index, name, value, setValue }) => {
    useEffect(() => {
        setValue(name, value);
    }, []);

    return (
        <div className='Inter_rate_row'>
            <div className='inter_wrapper mt-0'>
                {/* Minimum Duration Input */}
                <Controller
                    name={`custom_${prefix}_mins[${index}]`}
                    control={control}
                    rules={{ required: "Please enter minimum duration" }}
                    render={({ field }) => (
                        <div className='w-100'>
                            <input
                                className="input-in type_inp"
                                type="number"
                                placeholder={`${label} min`}
                                {...field}
                                onChange={(e) => field.onChange(Math.max(0, parseFloat(e.target.value)))}
                            />
                            {errors?.[`custom_${prefix}_mins`] && errors[`custom_${prefix}_mins`][index] && (
                                <ErrorMessage text={errors[`custom_${prefix}_mins`][index].message} />
                            )}
                        </div>
                    )}
                />

                {/* Time Unit Select */}
                <Controller
                    name={`custom_${prefix}_mins_time_unit[${index}]`}
                    control={control}
                    rules={{ required: "Please select one" }}
                    render={({ field }) => (
                        <div className='w-100'>
                            <Select
                                name={field.name}
                                options={filterUnit || []}
                                value={
                                    filterUnit?.find(opt => opt.value === field.value) || ""
                                }
                                isClearable={false}
                                disabledSearch
                                onChange={(selectedOption) => {
                                    field.onChange(selectedOption || "minute");
                                }}
                            />

                            {errors?.[`custom_${prefix}_mins_time_unit`] &&
                                errors[`custom_${prefix}_mins_time_unit`][index] && (
                                    <ErrorMessage text={errors[`custom_${prefix}_mins_time_unit`][index].message} />
                                )}
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

const CustomTiers = ({ control, errors, dispatch, item, setValue, unregister, watch }) => {
    const [tiers, setTiers] = useState([]);

    const getSelectedLanguages = () => {
        return tiers.flatMap(tier => tier.languages.map(lang => lang.value));
    };

    const addTier = () => {
        setTiers([...tiers, { id: Date.now(), languages: [] }]);
    };

    const removeTier = (id, index) => {
        setTiers(tiers.filter(tier => tier.id !== id));
        watch('custom_language_ids').splice(index, 1);

        watch('custom_opi_normal_rate').splice(index, 1);
        watch('custom_vri_normal_rate').splice(index, 1);
        watch('custom_inperson_normal_rate').splice(index, 1);
        watch('custom_opi_normal_rate_time_unit').splice(index, 1);
        watch('custom_vri_normal_rate_time_unit').splice(index, 1);
        watch('custom_inperson_normal_rate_time_unit').splice(index, 1);
        watch('custom_opi_normal_mins').splice(index, 1);
        watch('custom_vri_normal_mins').splice(index, 1);
        watch('custom_inperson_normal_mins').splice(index, 1);
        watch('custom_opi_normal_mins_time_unit').splice(index, 1);
        watch('custom_vri_normal_mins_time_unit').splice(index, 1);
        watch('custom_inperson_normal_mins_time_unit').splice(index, 1);

        watch('custom_opi_after_rate').splice(index, 1);
        watch('custom_vri_after_rate').splice(index, 1);
        watch('custom_inperson_after_rate').splice(index, 1);
        watch('custom_opi_after_rate_time_unit').splice(index, 1);
        watch('custom_vri_after_rate_time_unit').splice(index, 1);
        watch('custom_inperson_after_rate_time_unit').splice(index, 1);
        watch('custom_opi_after_mins').splice(index, 1);
        watch('custom_vri_after_mins').splice(index, 1);
        watch('custom_inperson_after_mins').splice(index, 1);
        watch('custom_opi_after_mins_time_unit').splice(index, 1);
        watch('custom_vri_after_mins_time_unit').splice(index, 1);
        watch('custom_inperson_after_mins_time_unit').splice(index, 1);
    };

    const loadLanguages = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        const selectedLanguages = getSelectedLanguages();
        return {
            options: result.data
                .map(val => ({ value: val.id, label: val.name }))
                .filter(lang => !selectedLanguages.includes(lang.value)),
            hasMore: page !== result?.last_page,
            additional: { page: page + 1 },
        };
    };
    useEffect(() => {
        if (item?.Custom_tier?.length) {
            setTiers(item.Custom_tier.map((tier, index) => ({
                id: tier.id || Date.now() + index,
                languages: tier.custom_tier_languages?.map(lang => ({ value: lang?.language?.id, label: lang?.language?.name })) || [],
            })));
            item?.Custom_tier?.forEach((tier, index) => {
                setValue(`custom_language_ids[${index}]`,
                    tier.custom_tier_languages?.map(lang => (lang?.language?.id)) || []
                );
            });


            item?.Custom_tier.forEach((tier, index) => {
                setValue(`custom_opi_normal_rate[${index}]`, tier.opi_normal_rate || '');
                setValue(`custom_vri_normal_rate[${index}]`, tier.vri_normal_rate || '');
                setValue(`custom_inperson_normal_rate[${index}]`, tier.inperson_normal_rate || '');
                setValue(`custom_opi_normal_rate_time_unit[${index}]`, tier.opi_normal_rate_time_unit || 'hour');
                setValue(`custom_vri_normal_rate_time_unit[${index}]`, tier.vri_normal_rate_time_unit || 'hour');
                setValue(`custom_inperson_normal_rate_time_unit[${index}]`, tier.inperson_normal_time_unit || 'hour');
                setValue(`custom_opi_normal_mins[${index}]`, tier.opi_normal_mins || '');
                setValue(`custom_vri_normal_mins[${index}]`, tier.vri_normal_mins || '');
                setValue(`custom_inperson_normal_mins[${index}]`, tier.inperson_normal_mins || '');
                setValue(`custom_opi_normal_mins_time_unit[${index}]`, tier.opi_normal_mins_time_unit || 'minute');
                setValue(`custom_vri_normal_mins_time_unit[${index}]`, tier.vri_normal_mins_time_unit || 'minute');
                setValue(`custom_inperson_normal_mins_time_unit[${index}]`, tier.inperson_normal_mins_time_unit || 'minute');

                setValue(`custom_opi_after_rate[${index}]`, tier.opi_after_rate || '');
                setValue(`custom_vri_after_rate[${index}]`, tier.vri_after_rate || '');
                setValue(`custom_inperson_after_rate[${index}]`, tier.inperson_after_rate || '');
                setValue(`custom_opi_after_rate_time_unit[${index}]`, tier.opi_after_rate_time_unit || 'hour');
                setValue(`custom_vri_after_rate_time_unit[${index}]`, tier.vri_after_rate_time_unit || 'hour');
                setValue(`custom_inperson_after_rate_time_unit[${index}]`, tier.inperson_after_time_unit || 'hour');
                setValue(`custom_opi_after_mins[${index}]`, tier.opi_after_mins || '');
                setValue(`custom_vri_after_mins[${index}]`, tier.vri_after_mins || '');
                setValue(`custom_inperson_after_mins[${index}]`, tier.inperson_after_mins || '');
                setValue(`custom_opi_after_mins_time_unit[${index}]`, tier.opi_after_mins_time_unit || 'minute');
                setValue(`custom_vri_after_mins_time_unit[${index}]`, tier.vri_after_mins_time_unit || 'minute');
                setValue(`custom_inperson_after_mins_time_unit[${index}]`, tier.inperson_after_mins_time_unit || 'minute');
            });
        }
    }, [item?.Custom_tier]);



    return (
        <>
            {(tiers).map((tier, index) => (
                <div key={tier.id} className="w-100 p-3">
                    <div className="row-primary">
                        <h2>Select Languages *</h2>
                        <Controller
                            name={`custom_language_ids[${index}]`}
                            control={control}
                            rules={{ required: "Languages must be specified" }}
                            render={({ field }) => (
                                <AsyncPaginate menuPlacement='auto' isMulti styles={selectCustomStyles}
                                    filterOption={
                                        (e) => {
                                            if (getSelectedLanguages().includes(e.value)) {
                                                return false;
                                            }
                                            else {
                                                return true;
                                            }
                                        }
                                    }
                                    value={tier.languages} loadOptions={loadLanguages} isClearable escapeClearsValue
                                    onChange={selected => {
                                        setTiers(tiers.map(t => t.id === tier.id ? { ...t, languages: selected } : t));
                                        field.onChange(selected.map(opt => opt.value));
                                    }}
                                    additional={{ page: 1 }} />
                            )}
                        />
                        {errors?.[`custom_language_ids[${index}]`]?.message &&
                            <ErrorMessage text={errors[`custom_language_ids[${index}]`].message} />
                        }

                        <IconButton color="error" onClick={() => removeTier(tier.id, index)}><i className="fa-solid fa-trash-can trash_icon"></i></IconButton>
                    </div>
                    {tier.languages.length > 0 && (
                        ["Normal", "After"].map(time => (
                            <div key={time}>
                                <h2 className='text-center my-3 fw-bold fst-italic'>{time} Hour</h2>
                                <div className='rate_container'>
                                    <div className='row-primary align-items-end'>
                                        <h2 className='mb-3 my-0'>Rates *:</h2>
                                        {["opi", "vri", "inperson"].map((type) => (
                                            <RateInputGroup key={type} label={type == 'inperson' ? 'Inperson' : type.toUpperCase()} control={control} prefix={`${type}_${time.toLowerCase().replace(' ', '_')}`} index={index} filterUnit={filterUnit} errors={errors}
                                                name={`custom_${`${`${type}_${time.toLowerCase().replace(' ', '_')}`}_rate_time_unit`}[${index}]`}
                                                value={"hour"}
                                                setValue={setValue}
                                                
                                            />
                                        ))}
                                    </div>
                                    <div className='row-primary align-items-end'>
                                        <h2 className='mb-3 my-0'>Minimum *:</h2>
                                        {["opi", "vri", "inperson"].map((type) => (
                                            <MinDurationInputGroup
                                                key={type}
                                                label={type === 'inperson' ? 'Inperson' : type.toUpperCase()}
                                                control={control}
                                                prefix={`${type}_${time.toLowerCase().replace(' ', '_')}`}
                                                index={index}
                                                filterUnit={filterUnit}
                                                errors={errors}
                                                name={`custom_${type}_${time.toLowerCase().replace(' ', '_')}_mins_time_unit[${index}]`}
                                                value={"minute"}
                                                setValue={setValue}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            ))}
            <button type="button" className='main_button' onClick={addTier}>Add Custom Tier</button>
        </>
    );
};

export default CustomTiers;